module.exports = __webpack_public_path__ + "images/thumb-58813a322a40e16f88384ce07bbfe937.jpg";